import { Observable, pipe, of, EMPTY, from, Observer, throwError } from 'rxjs';
import { switchMap, catchError, mergeMap, map, withLatestFrom } from 'rxjs/operators';
import { Epic, ofType, ActionsObservable } from 'redux-observable';

import Axios, { AxiosPromise, AxiosResponse, AxiosError } from 'axios';

import * as UserActions from './user.actions'
import { UserAction } from './user.actions';
import { hopplerApi } from '../../../../constants/api';
import * as RequestStates from '../../../../types/request-state.model';
import { User } from '../../../../types/user.model';

import URLRouter from '../../../utils/url-router';
import { ListResponse } from '../../../../types';
import { Group } from '../../../../types/group.model';

let userEffects: Epic[] = [];
const userBasePath = `${hopplerApi.host}/api/users`;

const test: Epic = test$ => test$.pipe(
  ofType<UserAction>(UserActions.TEST),
  switchMap(() => {

    console.log('test effect is alive');

    return of({
      type: UserActions.LOGOUT_SUCCESS
    } as UserAction);
  })
);

const getCurrentUser: Epic = getCurrentUser$ => getCurrentUser$.pipe(
  ofType<UserAction>(UserActions.GET_CURRENT_USER),
  switchMap((action: UserAction) => {

    const promise = Axios.get<User>(
      `${userBasePath}/me`,
      {
        withCredentials: true
      }
    );

    return from (promise).pipe(
      mergeMap((response) => {
        const currentUser: User = response.data[0];
        const action: UserAction = {
          type: UserActions.GET_CURRENT_USER_SUCCESS,
          payload: {
            currentUser: currentUser,
            getCurrentUserState: RequestStates.REQUEST_SUCCESS
          }
        }

        return of(action);
      }),
      catchError((errResp) => {
        const action: UserAction = {
          type: UserActions.GET_CURRENT_USER_FAIL,
          payload: {
            getCurrentUserState: RequestStates.REQUEST_FAILED
          }
        }

        setTimeout(() => {
          URLRouter.navigateToURL('/login');
        }, 250);
        
        return of(action);
      })
    );
  })
);

const getCurrentGroups: Epic = getCurrentGroups$ => getCurrentGroups$.pipe(
  ofType<UserAction>(UserActions.GET_CURRENT_USER),
  switchMap(() => {
    const promise = Axios.get<ListResponse<Group>>(
      `${hopplerApi.host}/kumita/groups`,
      { withCredentials: true }
    )

    return from(promise).pipe(
      mergeMap(response => of({
        type: UserActions.GET_GROUPS_SUCCESS,
        payload: { currentGroups: response.data.results }
      } as UserAction)),
      catchError((errResp) => of({
        type: UserActions.GET_GROUPS_FAIL
      } as UserAction))
    );
  })
)

const logout: Epic = logout$ => logout$.pipe(
  ofType<UserAction>(UserActions.LOGOUT),
  switchMap(() => {

    const promise = Axios.delete(
      `${userBasePath}/auth`,
      {
        withCredentials: true
      }
    );

    return from(promise).pipe(
      mergeMap(() => {
        const action: UserAction = {
          type: UserActions.LOGOUT_SUCCESS
        }
    
        // signupButtonToggle(false);

        // 250 ms before the route is changed
        setTimeout(() => {
          URLRouter.navigateToURL('/login');
        }, 250);

        return of(action);
      }),
      catchError(() => {
        const action: UserAction = {
          type: UserActions.LOGOUT_FAIL
        }
    
        return of(action);
      })
    );
  })
);

const checkPbRole: Epic = checkPbRole$ => checkPbRole$.pipe(
  ofType<UserAction>(UserActions.GET_CURRENT_USER_SUCCESS),
  switchMap((action: UserAction) => {
    const currentUser = action.payload.currentUser;

    // if (!currentUser.roles.includes('ROLE_PARTNER_BROKER')) {
    //   // alert('REDIRECTING');
    //   URLRouter.navigateToURL('/');
    // }

    return EMPTY;
  })
);

// ! Make sure to add created epics to array 

userEffects.push(test);
userEffects.push(getCurrentUser);
userEffects.push(getCurrentGroups);
userEffects.push(checkPbRole);
userEffects.push(logout);

export default userEffects;